import React from 'react';
import styled from 'styled-components';
import Color from 'color';
import { Link } from 'react-router-dom';
import { Map } from 'immutable';
import { string, instanceOf } from 'prop-types';
import { fontFamilyHeading, dynamicFontSize } from '../styles/helpers/mixins';
import { color, size } from '../styles/helpers/variables';
import { isValidHexColor } from '../util/isValidHexColor';
import { StartPageBlock } from '../styles/blocks/StartPageBlock';
import { Conditional } from './Conditional';

export const InfoBanner = props => {
  const { backgroundColor, headline, linkText, linkUrl, text } = props;

  if (!isValidHexColor(props.backgroundColor) || !headline || !text) return false;

  const isDark = isValidHexColor(props.backgroundColor) ? Color(props.backgroundColor).isDark() : false;

  return (
    <InfoBannerRoot backgroundColor={backgroundColor}>
      <InfoBannerHeading isDark={isDark}>{headline}</InfoBannerHeading>
      <InfoBannerText isDark={isDark}>{text}</InfoBannerText>

      <Conditional show={!!(linkText && linkUrl.get('url'))}>
        <InfoBannerLink to={linkUrl.get('url')}>
          <InfoBannerLinkText isDark={isDark}>{linkText}</InfoBannerLinkText>
        </InfoBannerLink>
      </Conditional>
    </InfoBannerRoot>
  );
};

const InfoBannerRoot = styled.div`
  background-color: ${props => props.backgroundColor};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 43px 20px 30px;

  @media screen and (min-width: ${size.medium}px) {
    padding: 43px 50px 30px;
  }

  @media screen and (min-width: ${size.xLarge}px) {
    padding: 43px 100px 30px;
  }
`;

const InfoBannerHeading = styled.h2`
  ${fontFamilyHeading};
  ${dynamicFontSize(28, 44)};
  line-height: 1.1;
  text-align: center;
  letter-spacing: normal;
  font-weight: normal;
  color: ${props => (props.isDark ? color.white : color.black)};
  width: 100%;
  margin: 0;
`;

const InfoBannerText = styled.p`
  max-width: 800px;
  line-height: 1.56;
  margin: 2em 0 1.5em;
  text-align: center;
  color: ${props => (props.isDark ? color.white : color.black)};

  @media screen and (min-width: ${size.large}px) {
    margin: 1.25em 0 15px;
  }
`;

const InfoBannerLink = styled(Link)`
  text-decoration: none;
  margin: 5px 0;
`;

const InfoBannerLinkText = styled(StartPageBlock.HeroLinkAsP)`
  text-transform: uppercase;
  letter-spacing: 2px;
  margin: 0;
`;

InfoBanner.defaultProps = {
  backgroundColor: null,
  headline: null,
  linkText: null,
  linkUrl: Map(),
  text: null
};

InfoBanner.propTypes = {
  backgroundColor: string,
  headline: string,
  linkText: string,
  linkUrl: instanceOf(Map),
  text: string
};



// WEBPACK FOOTER //
// ./src/components/InfoBanner.js